






















































































import Vue from 'vue';
import genres from '../data/genres';
import {ProjectInfoState as State} from '@/components/types/ProjectInfoState';
import Project from '@/types/Project';

export default Vue.extend({
    data() : {
        version: string,
        state: State,
        error: string,
    } {
        return {
            version: '',
            state: State.NotStarted,
            error: 'No error',
        };
    },

    computed: {
        project() {
            return this.$store.state.project.projectDef!.project;
        },
        genreName() {
            try {
                return genres[this.$store.state.project.projectDef!.project.genres[0]].name;
            } catch (e) {
                return 'No genre';
            }
        },
    },

    methods: {
        async handleSubmit(project: Project): Promise<void> {
            this.state = State.Saving;
            try {
                await this.$store.dispatch('submissions/submitProject', this.version);
                this.state = State.Done;
                await this.$router.push('/submitted');
            } catch (e) {
                this.error = e.message;
                this.state = State.Error;
            }
        },
    },
});
